import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { apiHolder as api, apis, ConvertTaskStatus, inWindow, getIn18Text, } from 'api';
import classnames from 'classnames';
import { message, Tooltip, Progress as CircleProgress } from 'antd';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import style from './index.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import { AttachmentActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions, doDownloadAttchmentAsync } from '@web-common/state/reducer/attachmentReducer';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { ProgressButton } from './download-button';
import TransferButton from '@web-common/components/UI/DownloadCard/TranferButton';
import { getTrail } from '@web-disk/utils';
import { getTrackedUrl } from '@web-common/utils/download_track';
const ALLOW_CONVERT_FILE_TYPE_SET = new Set(['xls', 'xlsx', 'docx']);
const LOADING_MESSAGE_KEY = 'convert_loading';
const CONVERT_TIMEOUT = 12e4;
const ProgressContext = React.createContext({ percent: 0 });
const ALLOW_FILE_TYPE = [
    'doc',
    'docx',
    'dot',
    'dotm',
    'dotx',
    'docm',
    'wps',
    'wpt',
    'ppt',
    'pptx',
    'pot',
    'potm',
    'potx',
    'pps',
    'ppsx',
    'pptm',
    'dps',
    'dpt',
    'xls',
    'xlsx',
    'xlsm',
    'xlt',
    'xltx',
    'xltm',
    'et',
    'ett',
    'rtf',
    'zip',
    'rar',
    'jar',
    'war',
    'ear',
    'crx',
    'sext',
    'ar',
    'cpio',
    '7z',
    'tar',
    'tgz',
    'taz',
    'tbz',
    'tbz2',
    'cpgz',
    'z',
    'bz',
    'bz2',
    'gz',
    '-gz',
    '-z',
    '_z',
    'htm',
    'html',
    'shtml',
    'xhtml',
    'xml',
    'txt',
    'ini',
    'inf',
    'java',
    'jsp',
    'js',
    'c',
    'cpp',
    'py',
    'h',
    'hpp',
    'cs',
    'sh',
    'css',
    'asp',
    'aspx',
    'mp3',
    'mp4',
    'wma',
    'flv',
    'eml',
    'jpg',
    'jpeg',
    'gif',
    'png',
    'pdf',
    'word',
    'xlsb',
    'xlst',
    'xps',
    'csv',
    'emf',
    'ppa',
];
function sleep(time) {
    return new Promise(resolve => {
        setTimeout(resolve, time);
    });
}
function Progress({ percent }) {
    return (React.createElement("div", { className: style.loading },
        React.createElement("div", { className: style.grey }, getIn18Text('ZHUANCUNZHONG')),
        React.createElement("div", { className: style.progress },
            React.createElement("div", { className: style.progressBar, style: { width: percent } })),
        React.createElement("div", { className: style.white },
            percent,
            "%")));
}
function getFileSuffix(filename) {
    const lastIndex = filename.lastIndexOf('.');
    if (lastIndex > -1) {
        return filename.slice(lastIndex + 1);
    }
    return '';
}
const trackerApi = api.api.requireLogicalApi('dataTrackerApiImp');
const CONVERT_EVENT_ID = 'pcMail_previewAttachment_convert';
var ConvertOperaType;
(function (ConvertOperaType) {
    ConvertOperaType["ButtonShow"] = "buttonshow";
    ConvertOperaType["Convert"] = "convert";
    ConvertOperaType["ConvertSuccess"] = "convertsuccess";
})(ConvertOperaType || (ConvertOperaType = {}));
function getConvertFileType(fileType) {
    if (fileType === 'docx') {
        return 'doc';
    }
    if (['xls', 'xlsx', 'csv'].includes(fileType)) {
        return 'sheet';
    }
    return '';
}
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const inElectron = systemApi.isElectron();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const fileApi = api.api.getFileApi();
const convertApi = api.api.requireLogicalApi('convertApiImpl');
const PreviewContent = props => {
    const { hash, onFetchDetail = () => { }, operateClose = true } = props;
    const { downloadProgress: downloadProgressRedux } = useAppSelector(state => state.attachmentReducer);
    const { downloadContentId: downloadContentIdRedux, downloadId: downloadIdRedux, attachments: attachmentsRedux = [], } = useAppSelector(state => state.attachmentReducer.attachmentsPreview);
    const [messageApi, contextHolder] = message.useMessage();
    const [index, setIndex] = useState(0);
    const [operateDisabled, setOperateDisabled] = useState(['']);
    const [iframeUrl, setIframeUrl] = useState('');
    const [previewUrl, setPreviewUrl] = useState('');
    const [list, setList] = useState(attachmentsRedux);
    const [attachments, setAttachments] = useState(attachmentsRedux);
    const [currentAccount, setCurrentAccount] = useState('');
    const downloadProgress = downloadProgressRedux;
    const [downloadContentId, setDownloadContentId] = useState(downloadContentIdRedux);
    const [downloadId, setDownloadId] = useState('');
    const [fileName, setFileName] = useState('');
    useEffect(() => {
        if (systemApi.isElectron()) {
            onFetchDetail(hash, { fileType: getTrail(fileName).toUpperCase(), name: fileName }, previewUrl);
        }
    }, [hash, attachments]);
    useMsgRenderCallback('attachmentPreviewInitData', (ev) => {
        var _a;
        if (ev && ev.eventData) {
            const url = new URL(ev.eventData.hash);
            if (hash !== url.hash && hash !== url.search) {
                return;
            }
            const _downloadContentId = systemApi.isElectron() ? ev.eventData.downloadContentId : downloadContentIdRedux;
            const _downloadId = systemApi.isElectron() ? ev.eventData.downloadId : downloadIdRedux;
            setDownloadContentId(_downloadContentId);
            setDownloadId(_downloadId);
            setFileName(ev.eventData.fileName);
            if (ev.eventData._account) {
                const emailId = accountApi.getEmailIdByEmail(ev.eventData._account);
                setCurrentAccount(emailId);
            }
            else {
                setCurrentAccount('');
            }
            setPreviewUrl((_a = ev.eventData.attachments[0]) === null || _a === void 0 ? void 0 : _a.filePreviewUrl);
            setAttachments(systemApi.isElectron() ? ev.eventData.attachments : attachmentsRedux);
        }
    });
    const dispatch = useAppDispatch();
    const clearProgress = () => dispatch(AttachmentActions.doUpdateDownloadProgress(0));
    const [loading, setLoading] = useState(false);
    const [percent, setPercent] = useState(0);
    const [isFailed, setIsFailed] = useState(false);
    const currentAttachment = list[index];
    const isTpMail = useMemo(() => {
        var _a;
        return ((_a = currentAttachment === null || currentAttachment === void 0 ? void 0 : currentAttachment.filePreviewUrl) === null || _a === void 0 ? void 0 : _a.indexOf('mail-plus/api/biz/email/attach')) !== -1;
    }, [currentAttachment]);
    const canConvert = ALLOW_CONVERT_FILE_TYPE_SET.has(getFileSuffix((currentAttachment === null || currentAttachment === void 0 ? void 0 : currentAttachment.fileName) || ''));
    const isUploadAttachment = (currentAttachment === null || currentAttachment === void 0 ? void 0 : currentAttachment.attType) == '1';
    const changeFileStatus = async (downloadInfo) => {
        let onOperateDisabled = ['open'];
        if (inElectron) {
            const fileInfo = await fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account: currentAccount }));
            const curFile = fileInfo && fileInfo.length > 0 ? fileInfo[0] : null;
            if (curFile) {
                const curFileStatus = curFile === null || curFile === void 0 ? void 0 : curFile.fileStatus;
                if (curFileStatus === 'downloaded') {
                    const isExits = await fileApi.testLocalFile(Object.assign(Object.assign({}, curFile), { _account: currentAccount }));
                    if (isExits) {
                        onOperateDisabled = ['doDownload'];
                    }
                    else {
                        fileApi.delFileInfo(Object.assign(Object.assign({}, curFile), { _account: currentAccount }));
                    }
                }
            }
        }
        if (index === 0) {
            onOperateDisabled.push('previous');
        }
        if (index === list.length - 1) {
            onOperateDisabled.push('next');
        }
        setOperateDisabled(onOperateDisabled);
    };
    useEffect(() => {
        const onList = downloadContentId ? attachments.filter(i => i.downloadContentId === downloadContentId) : [];
        const start = downloadId ? onList.findIndex(i => i.downloadId === downloadId) : 0;
        if (onList.length === 0) {
            return;
        }
        setList(onList);
        setIndex(start);
    }, [attachments, downloadId, downloadContentId]);
    useEffect(() => {
        const currentAttac = list[index];
        if (currentAttac) {
            dispatch(actions.doAttachmentPreview({ visible: true, downloadContentId: currentAttac.downloadContentId, downloadId: currentAttac.downloadId }));
            const attacFilePreviewUrl = currentAttac.filePreviewUrl;
            if (!attacFilePreviewUrl) {
                setIframeUrl('');
            }
            else {
                const transPreviewUrlWhiteList = ['/api/pub/preview', '/api/biz/email/attach/preview', 'api/biz/email/colleague/attach/preview'];
                const isPass = transPreviewUrlWhiteList.some(url => attacFilePreviewUrl.includes(url));
                if (!isPass) {
                    setIframeUrl(attacFilePreviewUrl);
                }
                else {
                    mailApi
                        .getFilePreviewUrl({ url: attacFilePreviewUrl, mid: currentAttachment.downloadContentId, _account: currentAccount || currentAttac._account || '' })
                        .then(res => {
                        if (!res.success || !res.data) {
                            console.warn(getIn18Text('YULANFUWUBAO'));
                        }
                        const src = res.data;
                        setIframeUrl(src);
                    })
                        .catch(e => {
                        setIsFailed(true);
                    });
                }
            }
            changeFileStatus(currentAttac);
        }
    }, [index, list, hash, attachments]);
    useEffect(() => {
        var _a;
        const eventId = eventApi.registerSysEventObserver('fsDownloadNotify', {
            name: 'downloadCard_' + ((_a = list[index]) === null || _a === void 0 ? void 0 : _a.fileUrl) + Math.random().toFixed(6),
            func: ev => {
                if (list[index] && ev.eventStrData === list[index].fileUrl) {
                    changeFileStatus(list[index]);
                }
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('fsDownloadNotify', eventId);
        };
    }, []);
    useEffect(() => {
        const currentAttac = attachments[index];
        if (inWindow() && currentAttac && currentAttac.fileName) {
            window.document.title = `预览-${currentAttac.fileName}`;
        }
    }, [index, list]);
    const convertToOnlineDoc = useCallback(() => {
        if (!(currentAttachment.downloadContentId && currentAttachment.id)) {
            return;
        }
        setLoading(true);
        const params = {
            mid: currentAttachment.downloadContentId,
            part: currentAttachment.id,
        };
        const hide = messageApi.open({
            key: LOADING_MESSAGE_KEY,
            className: style.message,
            type: 'loading',
            content: React.createElement(ProgressContext.Consumer, null, value => React.createElement(Progress, Object.assign({}, value))),
            duration: 0,
        });
        let flag = true;
        async function startProgress() {
            let p = 0;
            while (flag && p < 99) {
                p++;
                setPercent(p);
                const time = p < 10 ? 100 : 500;
                await sleep(time);
            }
        }
        startProgress();
        async function startConvert() {
            try {
                let task = { status: ConvertTaskStatus.Waiting };
                let taskId = '';
                try {
                    taskId = await convertApi.convertMailAttachment2Doc(params);
                }
                catch (err) {
                    task.status = ConvertTaskStatus.Failed;
                    task.failureReason = getIn18Text('ZHUANCUNSHIBAI');
                    if (err.message === 'timeout') {
                        task.failureReason = getIn18Text('QINGQIUCHAOSHI');
                    }
                    else if (err.data && !err.data.success && err.data.message) {
                        task.failureReason = err.data.message;
                    }
                }
                const startTime = Date.now();
                while (task.status === ConvertTaskStatus.Waiting) {
                    if (Date.now() - startTime > CONVERT_TIMEOUT) {
                        task.failureReason = getIn18Text('ZHUANHUANCHAOSHI');
                        break;
                    }
                    await sleep(5000);
                    try {
                        task = await convertApi.getMailAttachmentDocCovertStatus(taskId);
                    }
                    catch (err) {
                        console.log(err);
                    }
                }
                flag = false;
                if (task.status === ConvertTaskStatus.Completed) {
                    messageApi.open({
                        type: 'success',
                        key: LOADING_MESSAGE_KEY,
                        content: getIn18Text('ZHUANHUANCHENGGONG'),
                        duration: 1000,
                    });
                    const url = convertApi.getFileURL(task);
                    if (systemApi.isElectron()) {
                        systemApi.handleJumpUrl(-1, url);
                    }
                    else {
                        systemApi.openNewWindow(url);
                    }
                    trackerApi.track(CONVERT_EVENT_ID, {
                        operatype: ConvertOperaType.ConvertSuccess,
                        type: getConvertFileType(currentAttachment.fileType),
                    });
                }
                else {
                    messageApi.open({
                        type: 'error',
                        key: LOADING_MESSAGE_KEY,
                        content: task.failureReason || getIn18Text('ZHUANCUNSHIBAI'),
                        duration: 1000,
                    });
                }
            }
            catch (err) {
                console.error(err);
                flag = false;
                messageApi.open({
                    type: 'error',
                    key: LOADING_MESSAGE_KEY,
                    content: getIn18Text('WEIZHICUOWU'),
                    duration: 1000,
                });
            }
            setTimeout(() => hide(), 1000);
            setLoading(false);
            setPercent(0);
        }
        startConvert();
    }, [messageApi, currentAttachment]);
    useEffect(() => {
        if (canConvert) {
            trackerApi.track(CONVERT_EVENT_ID, {
                operatype: ConvertOperaType.ButtonShow,
                type: getConvertFileType(currentAttachment.fileType),
            });
        }
    }, [canConvert, currentAttachment]);
    const openDir = downloadInfo => {
        if (downloadInfo) {
            fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account: currentAccount })).then(result => {
                if (result && result.length > 0) {
                    fileApi.testLocalFile(Object.assign(Object.assign({}, result[0]), { _account: currentAccount })).then(bool => {
                        if (!bool) {
                            SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN11') }).then(() => {
                                clearProgress();
                            });
                        }
                    });
                    fileApi.show(Object.assign(Object.assign({}, result[0]), { _account: currentAccount }));
                }
                else {
                    SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN12') }).then(() => {
                        clearProgress();
                    });
                }
            });
        }
    };
    const doDownload = async (item) => {
        if (inElectron) {
            const trackedUrl = getTrackedUrl(item.fileUrl);
            const itemWithTrack = trackedUrl ? Object.assign(Object.assign({}, item), { fileUrlInUse: trackedUrl }) : item;
            const downloadFile = () => {
                clearProgress();
                fileApi
                    .saveDownload(itemWithTrack, {
                    throttleTime: 100,
                    flowScene: 'mail_read',
                    progressIndicator: (_, receivedBytes) => {
                        dispatch(AttachmentActions.doUpdateDownloadProgress(((receivedBytes || 1) / (item === null || item === void 0 ? void 0 : item.fileSize)) * 100));
                        setOperateDisabled(['doDownload']);
                    },
                    _account: currentAccount,
                })
                    .then((res) => {
                    const resData = res;
                    if (resData.succ) {
                        dispatch(AttachmentActions.doUpdateDownloadProgress(100));
                        setOperateDisabled(['open']);
                    }
                });
            };
            try {
                const fileInfo = await fileApi.getFileInfo(Object.assign(Object.assign({}, item), { _account: currentAccount }));
                const isFileExist = fileInfo && fileInfo.length > 0 ? await fileApi.testLocalFile(Object.assign(Object.assign({}, fileInfo[0]), { _account: currentAccount })) : false;
                if (!isFileExist) {
                    downloadFile();
                }
                else {
                    openDir(item);
                }
            }
            catch (error) {
                downloadFile();
            }
            return;
        }
        const trackedUrl = getTrackedUrl(item === null || item === void 0 ? void 0 : item.fileUrl);
        dispatch(doDownloadAttchmentAsync({
            fileName: item === null || item === void 0 ? void 0 : item.fileName,
            fileSize: item === null || item === void 0 ? void 0 : item.fileSize,
            fileUrl: trackedUrl || (item === null || item === void 0 ? void 0 : item.fileUrl) || '',
            _account: currentAccount,
        }));
    };
    const closeModal = () => {
        if (systemApi.isElectron() && window.electronLib) {
            systemApi.closeWindow();
        }
        else {
            dispatch(actions.doAttachmentPreview({ visible: false, downloadContentId, downloadId }));
        }
    };
    const operateClick = type => {
        var _a, _b;
        if (loading) {
            return;
        }
        if (operateDisabled.includes(type)) {
            return;
        }
        switch (type) {
            case 'previous':
                onFetchDetail && onFetchDetail(hash, { name: (_a = attachments[index - 1]) === null || _a === void 0 ? void 0 : _a.fileName });
                setIndex(i => i - 1);
                break;
            case 'next':
                onFetchDetail && onFetchDetail(hash, { name: (_b = attachments[index + 1]) === null || _b === void 0 ? void 0 : _b.fileName });
                setIndex(i => i + 1);
                break;
            case 'doDownload':
                doDownload(list[index]);
                break;
            case 'open':
                openDir(list[index]);
                break;
            case 'close':
                closeModal();
                break;
            default:
                break;
        }
    };
    const [modalHeight, serModalHeight] = useState(640);
    const onResizeListener = () => {
        const clientH = document.body.clientHeight;
        serModalHeight(clientH - 80);
    };
    useEffect(() => {
        onResizeListener();
        inWindow() && window.addEventListener('resize', onResizeListener);
        return () => {
            inWindow() && window.removeEventListener('resize', onResizeListener);
        };
    }, []);
    const operate = () => {
        let types = ['', 'doDownload', 'open'];
        if (!inElectron) {
            if (operateClose) {
                types = ['', 'doDownload', 'close'];
            }
            else {
                types = ['', 'doDownload'];
            }
        }
        return types.map((type, i) => {
            let res = React.createElement("div", { className: `${style.line}` });
            if (type) {
                res = React.createElement(IconCard, { type: type, style: { opacity: loading || operateDisabled.includes(type) ? '0.5' : '' } });
                if (type === 'doDownload' && ![0, 100].includes(downloadProgress)) {
                    res = React.createElement(CircleProgress, { width: 16, type: "circle", percent: downloadProgress, format: () => '' });
                }
            }
            return (React.createElement("div", { key: type + i, className: `${style.operateItem}`, onClick: () => {
                    operateClick(type);
                } }, res));
        });
    };
    const renderButtonText = () => {
        if (downloadProgress === 100) {
            return systemApi.isElectron() ? getIn18Text('DAKAI') : getIn18Text('WANCHENG');
        }
        return downloadProgress === 0 ? getIn18Text('XIAZAI') : getIn18Text('XIAZAIZHONG');
    };
    const renderContent = () => {
        var _a, _b, _c;
        if (!list.length)
            return null;
        const content = list[index] || {};
        const fileType = ((_c = (_b = (_a = content === null || content === void 0 ? void 0 : content.fileName) === null || _a === void 0 ? void 0 : _a.split('.')) === null || _b === void 0 ? void 0 : _b.pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || '';
        if (ALLOW_FILE_TYPE.includes(fileType)) {
            return React.createElement("iframe", { src: iframeUrl, width: "100%", height: "100%" });
        }
        return (React.createElement("div", { className: style.unsupportPage },
            React.createElement("div", { className: "sirius-empty sirius-empty-search" }),
            React.createElement("span", { style: {
                    color: 'rgba(38, 42, 51, 0.5)',
                    fontSize: 14,
                    marginTop: 30,
                    marginBottom: 18,
                } }, getIn18Text('BUZHICHIGAIGE')),
            React.createElement(ProgressButton, { onClick: () => doDownload(content), progress: downloadProgress }, renderButtonText())));
    };
    const isSubAccount = currentAccount && currentAccount.length ? true : false;
    const visibleSaveToDisk = !isUploadAttachment && !isSubAccount && !isTpMail && !['netCloudAtt', 'cloudAttCont'].includes(currentAttachment === null || currentAttachment === void 0 ? void 0 : currentAttachment.from);
    const visibleTransSiriusDoc = process.env.BUILD_ISELECTRON && !isUploadAttachment && !isSubAccount && canConvert && !isTpMail && !['netCloudAtt', 'cloudAttCont'].includes(currentAttachment === null || currentAttachment === void 0 ? void 0 : currentAttachment.from);
    return isFailed ? (React.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        React.createElement("div", { className: "m-list-empty" },
            React.createElement("div", { style: { textAlign: 'center', marginBottom: '30px', color: '#656363' } }, getIn18Text('JIAZAISHIBAI')),
            React.createElement("div", { className: "sirius-empty sirius-empty-doc", style: { marginBottom: '20px' } })))) : (React.createElement("div", { className: `${style.previewAttachment}`, style: {
            height: `${modalHeight}px`,
        } },
        React.createElement("div", { className: `${style.header}` },
            React.createElement("div", { className: `${style.title}` }, list[index === null || index === void 0 ? void 0 : index.fileName]),
            React.createElement("div", { className: `${style.operate}` },
                visibleSaveToDisk && (React.createElement("div", { className: classnames(style.button, { [style.grey]: true }) },
                    React.createElement(TransferButton, { downloadInfo: list[index] }, getIn18Text('CUNDAOGERENKONG')))),
                visibleTransSiriusDoc && (React.createElement(Tooltip, { overlay: getIn18Text('LINGCUNWEIZAIXIAN') },
                    React.createElement("div", { className: classnames(style.button, { [style.disabled]: loading }), onClick: () => {
                            if (loading) {
                                return;
                            }
                            convertToOnlineDoc();
                            trackerApi.track(CONVERT_EVENT_ID, {
                                operatype: ConvertOperaType.Convert,
                                type: getConvertFileType(currentAttachment.fileType),
                            });
                        } },
                        getIn18Text('ZHUANWEIXIETONGWEN'),
                        React.createElement(ProgressContext.Provider, { value: { percent } }, contextHolder)))),
                operate())),
        React.createElement("div", { className: `${style.contentWrap}`, style: { height: '100%' } }, renderContent())));
};
export default PreviewContent;
